import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { RootState } from "../store";
import ChangePasswordGate from "./ChangePasswordGate";
import { isTeamAdmin } from "../util/manageAuth";

export default function ProtectedRoute() {
  const user = useSelector((state: RootState) => state.user);

  if (!user?.user?.role) return <Navigate to="/login" replace />;
  if (user.user.mustChangePassword) return <ChangePasswordGate name={user.user.userName} />;
  return <Outlet />;
}

/** Pages for the owner and org admins only (billing, team, API keys, WhatsApp number); agents go to the dashboard. */
export function TeamAdminRoute() {
  return isTeamAdmin() ? <Outlet /> : <Navigate to="/admin/dashboard" replace />;
}
